<template>
  <panel class="case-monitors" title="Monitors" color="green-3">
    <div class="case-monitors-content">
      <case-monitor-procedures :case-conf="caseConf" :readonly="readonly" @update="update" />
      <monitor-selector
        :value="caseConf.monitorMetadata.monitorModel"
        :disabled="readonly"
        @input="monitorModel => updateMonitorModel(monitorModel)"
      />
    </div>
  </panel>
</template>

<script>
import Panel from '../../common/Panel';
import MonitorSelector from '../MonitorSelector';
import CaseMonitorProcedures from '../CaseMonitorProcedures';

export default {
  name: 'case-monitor-actions',
  components: {
    Panel,
    MonitorSelector,
    CaseMonitorProcedures,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateMonitorModel(monitorModel) {
      this.update({ monitorMetadata: { monitorModel } });
    },
    update(updates) {
      this.$emit('update', updates);
    },
  },
};
</script>

<style scoped>
.case-monitors-content {
  display: flex;
}

.case-monitor-procedures {
  flex: 3;
}

.monitor-selector {
  flex: 1;
}
</style>